import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "strokeWidth", "viewBox"];
import React from 'react';

var CircleLoader = function CircleLoader(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid' : _ref$preserveAspectRa,
      _ref$strokeWidth = _ref.strokeWidth,
      strokeWidth = _ref$strokeWidth === void 0 ? 0 : _ref$strokeWidth,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 100 100' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: preserveAspectRatio,
    strokeWidth: strokeWidth,
    viewBox: viewBox
  }, unhandledProps), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-54, 50, 50)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(82,50) rotate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "0",
    cy: "0",
    r: "4",
    fill: "#0051b2",
    fillOpacity: "1"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-1.0799999999999998s",
    values: "1 1;1 1",
    keyTimes: "0;1",
    dur: "1.2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.2s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-1.0799999999999998s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.88854381999832,68.80912807335915) rotate(36)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "0",
    cy: "0",
    r: "4",
    fill: "#0051b2",
    fillOpacity: "0.9"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.96s",
    values: "1 1;1 1",
    keyTimes: "0;1",
    dur: "1.2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.2s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.96s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.88854381999832,80.43380852144492) rotate(72)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "0",
    cy: "0",
    r: "4",
    fill: "#0051b2",
    fillOpacity: "0.8"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.8400000000000001s",
    values: "1 1;1 1",
    keyTimes: "0;1",
    dur: "1.2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.2s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.8400000000000001s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.11145618000168,80.43380852144492) rotate(108)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "0",
    cy: "0",
    r: "4",
    fill: "#0051b2",
    fillOpacity: "0.7"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.72s",
    values: "1 1;1 1",
    keyTimes: "0;1",
    dur: "1.2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.2s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.72s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.111456180001685,68.80912807335915) rotate(144)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "0",
    cy: "0",
    r: "4",
    fill: "#0051b2",
    fillOpacity: "0.6"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.6s",
    values: "1 1;1 1",
    keyTimes: "0;1",
    dur: "1.2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.2s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.6s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18,50.00000000000001) rotate(180)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "0",
    cy: "0",
    r: "4",
    fill: "#0051b2",
    fillOpacity: "0.5"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.48s",
    values: "1 1;1 1",
    keyTimes: "0;1",
    dur: "1.2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.2s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.48s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.11145618000168,31.190871926640863) rotate(216)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "0",
    cy: "0",
    r: "4",
    fill: "#0051b2",
    fillOpacity: "0.4"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.36s",
    values: "1 1;1 1",
    keyTimes: "0;1",
    dur: "1.2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.2s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.36s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.11145618000168,19.566191478555087) rotate(252)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "0",
    cy: "0",
    r: "4",
    fill: "#0051b2",
    fillOpacity: "0.3"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.24s",
    values: "1 1;1 1",
    keyTimes: "0;1",
    dur: "1.2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.2s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.24s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.88854381999831,19.566191478555083) rotate(288)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "0",
    cy: "0",
    r: "4",
    fill: "#0051b2",
    fillOpacity: "0.2"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.12s",
    values: "1 1;1 1",
    keyTimes: "0;1",
    dur: "1.2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.2s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.12s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.88854381999832,31.190871926640856) rotate(324)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "0",
    cy: "0",
    r: "4",
    fill: "#0051b2",
    fillOpacity: "0.1"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "0s",
    values: "1 1;1 1",
    keyTimes: "0;1",
    dur: "1.2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1.2s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "0s"
  })))));
};

CircleLoader.displayName = 'CircleLoader';
export default CircleLoader;